import { ParticipantList, SuccessInfoDialog } from 'components';
import { Button } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { InviteIcon } from 'assets';
import { InviteClientPopup } from 'pages/LinkPage/components';
import { ConfirmResultEnum, IDialogContext } from 'context';
import { useDialog, useRoomHost, useRoomRightSidebar, useScreenSize } from 'hooks';
import { MenuItem } from '../MenuItem';
import styles from './ParticipantsMenu.module.scss';

type ParticipantsMenuProps = {
  className?: string;
};

export function ParticipantsMenu({ className }: ParticipantsMenuProps): JSX.Element {
  const { t, i18n } = useTranslation('providerRoom');
  const { isHost } = useRoomHost();
  const { confirm, showDialog }: IDialogContext = useDialog();
  const { hideSidebar } = useRoomRightSidebar();
  const { isDesktop } = useScreenSize();
  const isRtl = i18n.dir() === 'rtl';

  const handleInviteClick = async (): Promise<void> => {
    const confirmationResult = await confirm({ content: InviteClientPopup });
    if (confirmationResult === ConfirmResultEnum.Confirm) {
      const modal = showDialog(SuccessInfoDialog, {
        buttonText: t('done'),
        title: t('successTitle'),
        text: t('invitationSent'),
        onConfirm: () => {
          modal.destroy();
        },
      });
    }
  };

  const headerAction = isHost ? (
    <Button
      variant='contained'
      size='small'
      className={styles.inviteHeaderButton}
      onClick={handleInviteClick}
      sx={{
        minWidth: '9.6rem',
        height: '3rem',
        gap: '0.6rem',
      }}
    >
      {!isRtl && <InviteIcon className={styles.inviteIcon} />}
      <span>{t('invite')}</span>
      {isRtl && <InviteIcon className={styles.inviteIcon} />}
    </Button>
  ) : undefined;

  return (
    <>
      <MenuItem title={t('menus.participants')} className={className} headerAction={headerAction}>
        <ParticipantList onAfterOpenChat={!isDesktop ? hideSidebar : undefined} />
      </MenuItem>
    </>
  );
}
